import React from 'react';
import TextField from '@mui/material/TextField';
import { withFormik, withTooltip, wrapForDisabledTooltip } from './helpers';

export default function Select({
    children, slotProps, ...rest
}) {
    const nativeOverride = slotProps?.select?.native;
    const nativeDefault = true;
    const isNative = typeof nativeOverride === 'boolean' ? nativeOverride : nativeDefault;

    // A native <select> always displays one of its options, so its floating
    // label must always be shrunk above the box. MUI only shrinks it from the
    // value, so a select whose value is '' (a placeholder option, or "First
    // selected") first rendered with the label drawn over the option text
    // until something re-rendered it. Callers may still override shrink.
    const inputLabel = isNative
        ? { shrink: true, ...slotProps?.inputLabel }
        : slotProps?.inputLabel;

    return (
        <TextField
            fullWidth
            select
            slotProps={{
                ...slotProps,
                ...(inputLabel ? { inputLabel } : {}),
                select: {
                    native: nativeDefault,
                    ...slotProps?.select,
                },
            }}
            {...rest}
        >
            {isNative
                ? children
                : React.Children.map(children, wrapForDisabledTooltip)}
        </TextField>
    );
}

export const SelectWithFormik = withFormik(Select, { hasErrorState: true, defaultOptimize: false });
export const SelectWithInfoTooltip = withTooltip(Select);
export const SelectWithFormikAndTooltip = withTooltip(SelectWithFormik);
export const SelectWithInfoTooltipAndFormik = withFormik(
    SelectWithInfoTooltip,
    { hasErrorState: true, defaultOptimize: false }
);
